var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 38,
    viewBox: "0 0 62 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.7071 8.70711C62.0976 8.31658 62.0976 7.68342 61.7071 7.29289L55.3432 0.928932C54.9526 0.538408 54.3195 0.538408 53.9289 0.928932C53.5384 1.31946 53.5384 1.95262 53.9289 2.34315L59.5858 8L53.9289 13.6569C53.5384 14.0474 53.5384 14.6805 53.9289 15.0711C54.3195 15.4616 54.9526 15.4616 55.3432 15.0711L61.7071 8.70711ZM1 9H61V7H1V9Z",
    fill: "#D6D6D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.292889 30.7071C-0.0976334 30.3166 -0.0976334 29.6834 0.292889 29.2929L6.65685 22.9289C7.04737 22.5384 7.68054 22.5384 8.07106 22.9289C8.46159 23.3195 8.46159 23.9526 8.07106 24.3431L2.41421 30L8.07106 35.6569C8.46159 36.0474 8.46159 36.6805 8.07106 37.0711C7.68054 37.4616 7.04737 37.4616 6.65685 37.0711L0.292889 30.7071ZM61 31H0.999996V29H61V31Z",
    fill: "#D6D6D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowS);
export default __webpack_public_path__ + "static/media/arrow-s.84d3e12e5e3278f3fcbcf20dacd0ca65.svg";
export { ForwardRef as ReactComponent };